import { fetchFfdJson } from 'shared/api/ffdClient';

interface ErrorCodesApiResponse {
  text?: string;
  body?: {
    error_codes?: Record<string, string>;
  };
}

export interface FetchErrorCodesResult {
  codes: Record<string, string>;
  errorMessage: string;
}

export const fetchErrorCodes = async (authToken: string): Promise<FetchErrorCodesResult> => {
  try {
    const { response, data } = await fetchFfdJson<ErrorCodesApiResponse>('/error_codes', authToken);

    if (!response.ok) {
      return {
        codes: {},
        errorMessage: data.text ?? `エラーコード辞書の取得に失敗しました。(HTTP ${response.status})`,
      };
    }

    const codes = data.body?.error_codes;
    if (!codes || typeof codes !== 'object') {
      return {
        codes: {},
        errorMessage: 'エラーコード辞書のレスポンス形式が不正です。',
      };
    }

    return { codes, errorMessage: '' };
  } catch (_error) {
    return {
      codes: {},
      errorMessage: 'エラーコード辞書の取得に失敗しました。',
    };
  }
};
